<template>
  <div id="app">
    <div style="position: fixed; width: 100%; z-index: 1000;" class="d-flex flex-column flex-md-row align-items-center p-3 px-md-4 mb-3 bg-white border-bottom shadow-sm">
      <h5 class="my-0 mr-md-auto font-weight-normal" style="transform: translateY(3px);">
        <span style="display: inline-block">
          <database-icon size="1.5x" style="transform: translateY(-3px)" class="mr-2"></database-icon> <strong>data</strong><span class="d-none d-lg-inline">.silversky.dev</span>
        </span> |
        <span style="display: inline-block; width: 80px;"><strong>{{selected}}</strong></span>
      </h5>
      <nav class="my-2 my-md-0 mr-md-3">
        <a class="p-3 text-dark" style="cursor: pointer;" v-on:click="route('')">Home</a>
        <a class="p-3 text-dark" style="cursor: pointer;" v-on:click="route('#browse')">Browse</a>
        <a class="p-3 text-dark" style="cursor: pointer;" v-on:click="route('#examples')">Examples</a>
        <a class="p-3 text-dark" style="cursor: pointer;" v-on:click="route('#status')">Status</a>
        <div class="d-none d-md-inline-block mx-2">
          <div v-bind:class="{'table-success': (timing >= 0 && timing <= 1000), 'table-warning': (timing > 1000 && timing < 5000), 'table-danger': (timing >= 5000) }" v-bind:title="timing + ' ms'" style="width: 20px; height: 20px; border-radius: 10px; transform: translateY(4px)"></div>
        </div>
      </nav>
      <a class="d-none d-md-block btn btn-outline-primary" href="mailto:adrian.rabenseifner@silversky.ch">
        <mail-icon size="1.0x" style="transform: translateY(-2px)" class="mr-1"></mail-icon> Contact
      </a>
    </div>

    <div class="d-none d-md-block" style="height: 80px;"></div>
    <div class="d-block d-md-none" style="height: 120px;"></div>

    <div class="container">
      <component :is="selected"></component>

      <Footer />
    </div>
  </div>
</template>

<script>
  import {
    DatabaseIcon,
    MailIcon
  } from 'vue-feather-icons'

  import Home from './components/Home.vue'
  import Browse from './components/Browse.vue'
  import Status from './components/Status.vue'
  import Examples from './components/Examples.vue'
  import Footer from './components/Footer.vue'

  const routes = {
    '': 'Home',
    '#browse': 'Browse',
    '#examples': 'Examples',
    '#status': 'Status'
  }

  export default {
    name: 'app',
    components: {
      Home,
      Browse,
      Status,
      Examples,
      Footer,
      DatabaseIcon,
      MailIcon
    },
    data: function() {
      return {
        selected: routes[window.location.hash],
        featured: [
          'latest',
          'all/BTCUSD',
          'latest/SWX:*',
          'latest/10/SWX:ROG',
          'historic/2019-11-21/coin'
        ],
        query: '',
        lastRequest: 0,
        lastResponse: 0,
        timing: 0
      };
    },
    methods: {
      browse: function(query) {
        this.route('#browse');
        this.query = query;
      },
      route: function(route) {
        this.selected = routes[route];
        history.pushState({route}, '', route);
      }
    },
    created: function() {
      const self = this;

      const update = function() {
        self.lastRequest = Date.now();
        self.lastResponse = null;
        fetch("/check")
          .then(response => response.json()).then(function() {
            self.lastResponse = Date.now();
          });
      }

      update();
      setInterval(update, 10000);

      const calculateTiming = function() {
        if (self.lastResponse) {
          self.timing = self.lastResponse - self.lastRequest;
        } else {
          var ms = Date.now() - self.lastRequest;
          if (ms > self.timing) {
            self.timing = ms;
          }
        }

      }
      setInterval(calculateTiming, 500);

      window.onpopstate = function(event) {
        if(event.state) {
          self.selected = routes[event.state.route];
        }
      }
    }
  }
</script>

<style>
  body {
    overflow-y: scroll;
  }
</style>
